// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customDialog[data-v-6e9beaf1] .van-dialog,.customDialog[data-v-6e9beaf1] .van-dialog__content{background:transparent}.customDialog[data-v-6e9beaf1] .van-dialog__content .imgs{width:100%}", ""]);
// Exports
module.exports = exports;
